import React from 'react';
import { CLAIM_STATUS_BADGE } from '../../../dtos/billing/claims.dto';
import type { ClaimStatus } from '../../../dtos/billing/claims.dto';

const ClaimStatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const config = CLAIM_STATUS_BADGE[status as ClaimStatus] ?? { label: status, className: 'bg-gray-100 text-gray-600' };
  return (
    <span className={`inline-block whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${config.className}`}>
      {config.label}
    </span>
  );
};

export default ClaimStatusBadge;
